import { useCallback } from 'react';
import { Segment } from '../../../../services/analytics-services/segment';

const ASN_GRID_VIEW_TRACKING = 'ASN_GRID_VIEW_TRACKING';

export const AsnTableViewSegmentEvents = {
  OPEN_ASN_DASHBOARD: 'openAsnDashboard',
  CLICK_ACTION_CELL: 'clickActionCell',
  CANCEL_ASN: 'cancelAsn',
  DELETE_ASN: 'deleteAsn',
  DUPLICATE_ASN: 'duplicateAsn',
};

export const useAsnTableViewSegmentTracking = () => {
  return useCallback((event, data = {}) => {
    const params = {
      type: ASN_GRID_VIEW_TRACKING,
      ...data,
    };
    setTimeout(() => Segment.trackEvent(event, params), 0);
  }, []);
};
